
        import Symbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-rescls-trackers_group",
  "use": "icon-rescls-trackers_group-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-rescls-trackers_group\"><path fill=\"#3498db\" d=\"m8.001 3.573-.802-1.146A1 1 0 0 0 6.379 2H1a1 1 0 0 0-1 1v3h24V5a1 1 0 0 0-1-1H8.821a1 1 0 0 1-.82-.427\" /><path fill=\"#aec8e0\" d=\"M15.136 9H16.5v15h-1.364zm2.728 0h1.364v15h-1.364zm2.727 0h1.364v15h-1.364z\" /><path fill=\"#3498db\" d=\"M23 21.955h-8.909a1 1 0 0 1-1-1v-8.909a1 1 0 0 1 1-1H23a1 1 0 0 1 1 1v8.909a1 1 0 0 1-1 1\" /><path fill=\"#fff\" d=\"M18.545 13.091c-1.488 0-2.699 1.187-2.699 2.646 0 .577.186 1.125.536 1.583l1.823 2.42a.426.426 0 0 0 .68 0l1.821-2.417a2.6 2.6 0 0 0 .538-1.585c0-1.46-1.21-2.647-2.699-2.647m0 3.818a1.174 1.174 0 0 1-1.172-1.172c0-.646.526-1.172 1.172-1.172s1.172.526 1.172 1.172-.525 1.172-1.172 1.172\" /><path fill=\"#68ace0\" d=\"M12.091 20.955v-8.909c0-1.103.897-2 2-2h.045V9a1 1 0 0 1 1-1h6.82a1 1 0 0 1 1 1v1.045H23c.366 0 .705.106 1 .278V7H0v14a1 1 0 0 0 1 1h11.394a2 2 0 0 1-.303-1.045\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-rescls-trackers_group"/>
                </svg>
            );
        };

        Icon.id = "icon-rescls-trackers_group";

        export default Icon;
    